export const LEARNERS_PER_PAGE = 15;
export const EXPORT_PAGE_SIZE = 100;
